import React from 'react';
import { ChevronDown } from '@carbon/icons-react';
import { Box } from '@material-ui/core';
import { colorSet } from '@components/Provider';
import { Spotlight, useSpotlight } from '@components/Spotlight';
import AnnotationDetailDrawer from '@components/Chat/ChatMenu/Viewer/components/AnnotationDetailDrawer';
import { TutorialStepProps } from '../CapaViewTutorial';

const TutorialStep2_2 = ({
  handleNextStep,
  mockAnnotation
}: TutorialStepProps) => {
  const { load, width, height } = useSpotlight();

  return (
    <>
      {load && (
        <Spotlight
          cutOutTarget={{ x: '50%', y: '100%' }}
          radiusSize={421}
          CTATitle={
            <Box display={'flex'} alignItems={'center'}>
              주석달기 클릭
              <ChevronDown color={colorSet.primary500} size={26} />
            </Box>
          }
          CTADirection={'top'}
          CTADescription={'작성된 주석에 답글도 남기며 소통할 수 있어요.'}
          handleNextStep={() => handleNextStep('3')}
          addX={0}
          addY={-330}
          clientHeight={height}
          clientWidth={width}
        />
      )}
      <AnnotationDetailDrawer
        annotation={mockAnnotation}
        open={true}
        onClose={() => ({})}
      />
    </>
  );
};

export default TutorialStep2_2;
